<template>
  <LayoutSidePage>
    <h1 class="font-semibold my-6 text-4xl">
      {{ $t('pages.404.title') }}
    </h1>
    <p>{{ $t('pages.404.description') }}</p>
  </LayoutSidePage>
</template>

<script>
export default {
  name: 'Error404',

  mounted() {
    window.prerenderReady = true; // For pre-rendering SEO purpose
  },

  metaInfo() {
    return {
      title: this.$t('pages.404.title'),
      meta: [
        { vmid: 'description', name: 'description', content: this.$t('pages.404.description') },
        { vmid: 'og:description', property: 'og:description', content: this.$t('pages.404.description') },
        { vmid: 'thumbnail', property: 'thumbnail', content: require('@/assets/images/defaultMetaThumbnail.jpg') },
        { vmid: 'og:image', property: 'og:image', content: require('@/assets/images/defaultMetaImage.jpg') },
        { vmid: 'og:image:width', property: 'og:image:width', content: '500' },
        { vmid: 'og:image:height', property: 'og:image:height', content: '350' },
        { vmid: 'twitter:image', property: 'twitter:image', content: require('@/assets/images/defaultMetaImage.jpg') }
      ]
    };
  }
};
</script>
